import {needAuth} from "../instance/Instance";
import {commonResponseMessage, getPages} from "../../components/commonmethod/CommonMethod";

async function getPurchase(id) {
    console.log(">>> api : 구매 단건 조회")
    return  await needAuth.get('/purchase/'+ id);
}

async function getPurchaseList(search, pageable) {
    const start = performance.now();
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;
    try{
        return  await needAuth.post('/purchase?'+pageStr,search);
    }catch (error){
        return error;
    }finally {
        const end = performance.now(); // 함수 호출 후 현재 시간 측정
        const executionTime = ((end - start)/1000).toFixed(2); // 함수 실행에 걸린 시간 계산
        console.log(`>>> api : 구매 리스트 조회 완료시간 : ${executionTime} 초`);
    }
}


async function createPurchase(purchase, files) {
    console.log(">>> api : 구매 등록")
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    formData.append(
        "purchaseRequestDto",
        new Blob([JSON.stringify(purchase)], { type: "application/json" })
    );
    return await needAuth.post(
        '/purchase/create',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );

}

async function updatePurchase(data) {
    return await needAuth.put(`/purchase`, data);
}


async function updatePurchaseHandler(id, handlerId, add, name) {
    if(add) {
        let response =  await needAuth.put(`/purchase/${id}/add-handler/${handlerId}/${name}`);
        return commonResponseMessage(response, add, "담당자");
    }
    else {
        let response =  await needAuth.delete(`/purchase/${id}/remove-handler/${handlerId}/${name}`);
        return commonResponseMessage(response, add,"담당자");
    }
}

async function updatePurchaseAsset(id, assetId, add) {
    if(add) {
        let response = await needAuth.put(`/purchase/${id}/add-asset/${assetId}`);
        return commonResponseMessage(response, add,"자산");
    }
    else{
        let response =   await needAuth.delete(`/purchase/${id}/remove-asset/${assetId}`);
        return commonResponseMessage(response, add,"자산");
    }

}


async function removePurchases(ids) {

        let response = await needAuth.put('/purchase/delete', ids);
        return response;

}


async function createPurchaseAssets(id, asset) {
    const purchaseAssets ={ purchase:{ id : id }, asset : {id : asset} }
    return await needAuth.post(`/purchase/assets/create`, purchaseAssets);
}

async function removePurchaseAssets(id, asset) {
    return await needAuth.delete(`/purchase/assets/delete?id=`+id+`&asset=`+asset);
}

async function getPurchaseListByAsset(assetId, pageable) {
    try{
        return  await needAuth.get(`/purchase/asset/${assetId}?`+getPages(pageable));
    }catch (error){
        return error;
    }
}




export {getPurchase, getPurchaseList, createPurchase, updatePurchase, updatePurchaseHandler, updatePurchaseAsset, removePurchases, createPurchaseAssets, removePurchaseAssets, getPurchaseListByAsset};